// extracted by mini-css-extract-plugin
export default {"wrapper":"Popper_wrapper__npzYb","popperAccount":"Popper_popperAccount__Ysgxs","arrow":"Popper_arrow__b1Yay"};